import type { IFluxoPagamento } from '@/shared/interfaces/fluxo-pagamento.types'
import { HttpService } from '@/shared/lib/http'

export class GetFluxoPagamentosService extends HttpService {
  execute = async (ids: string[]) => {
    return this.http.get<IFluxoPagamento[]>('api/v2/Simulacao/fluxoPagamento', {
      params: { ids },
      paramsSerializer: { indexes: null },
    })
  }
}
